// Avoid re-exports in favor of direct imports or entry-point files
/* eslint-disable no-barrel-files/no-barrel-files */

import React from 'react';

import { fg } from '@confluence/feature-gating';
import { LoadableBackground } from '@confluence/loadable';

const NthUserOrientationLoadable = LoadableBackground({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-NthUserOrientation" */ './NthUserOrientationInner.tsx'
			)
		).NthUserOrientation,
});

export const NthUserOrientation = () => {
	return fg('cc_nth_user_orientation_eligibility_checks') ? <NthUserOrientationLoadable /> : null;
};
